import './posts-slider.scss'
import _ from 'lodash'

export default {
    name: 'posts-slider',

    data: {
        index: 0
    },

    computed: {
        isMobile () {
            const mqSet = window.theme.mediaquery.get()
            const mqSmall = _.find(mqSet, mqObj => mqObj.name === 'small')
            const mqMedium = _.find(mqSet, mqObj => mqObj.name === 'medium')
            return mqSmall.mql.matches || mqMedium.mql.matches
        },

        sliderWidth () {
            if (this.isMobile) {
                return `${100 * this.posts.length}%`
            } else {
                if (this.posts && this.posts.length) {
                    return ((100 / 3) * this.posts.length) + '%'
                } else {
                    return '100%'
                }
            }
        },

        sliderTransform () {
            if (this.posts && this.posts.length) {
                return `translateX(${(100 / this.posts.length) * -this.index }%)`
            } else {
                return 'none'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/posts-slider/posts-slider.js